import { CLOUD_FUNCTIONS_URL } from '@/data/constants';

export default function (filePath: string): string {
  return `${CLOUD_FUNCTIONS_URL}/signed_url?file=${filePath}`;
}
